import * as React from 'react'
import { DiagramEngine, PortWidget } from '@projectstorm/react-diagrams-core'
import { ApplicationArchitectureNodeModel } from './application-architecture-node-model'
import { css, cx } from '@emotion/css'
import { appArchitecturePortOut } from './index'
import { getColumnContainerStyle } from '../../index'

export interface Props {
  readonly node: ApplicationArchitectureNodeModel
  readonly engine: DiagramEngine
}

export class ApplicationArchitectureNodeWidget extends React.Component<Props> {
  public render() {
    const { node, engine } = this.props

    const portOut = node.getPort(appArchitecturePortOut)

    return (
      <div
        className={cx(
          getColumnContainerStyle(0),
          css`
            height: 100%;
            margin-bottom: 20px;
          `
        )}
      >
        {!!portOut && (
          <PortWidget
            engine={engine}
            port={portOut}
            className={css`
              position: absolute;
              top: 50%;
              right: 0;
            `}
          />
        )}
      </div>
    )
  }
}
